import { DEFINITION_BY_ID } from "./definitions"
import { MARKER_CLOSE, MARKER_OPEN } from "./markers"
import { stripAllPua } from "./strip"

/**
 * マーカー整合の検証。合格条件（行単位で判定し、マーカーの行跨ぎは不合格）:
 * - U+E000/U+E001 の直後に登録済みID文字が続く
 * - 終了IDが直近の未クローズ開始IDと一致し、行末で全て閉じている
 * - 上記マーカー以外のPUA文字が存在しない
 *
 * 検証コードのシンプルさ自体が信頼性の根拠なので、ここに機能を足さないこと。
 */
export function validateMarkers(text: string): boolean {
  return text.split(/\r?\n/).every(validateLine)
}

function isPuaCodePoint(code: number): boolean {
  return (
    (code >= 0xe000 && code <= 0xf8ff) || (code >= 0xf0000 && code <= 0xffffd) || (code >= 0x100000 && code <= 0x10fffd)
  )
}

function validateLine(line: string): boolean {
  const stack: string[] = []
  const chars = [...line]
  for (let i = 0; i < chars.length; i++) {
    const ch = chars[i]
    if (ch === undefined) {
      continue
    }
    if (ch === MARKER_OPEN) {
      const id = chars[i + 1]
      if (id === undefined || !DEFINITION_BY_ID.has(id)) {
        return false
      }
      stack.push(id)
      i++
    } else if (ch === MARKER_CLOSE) {
      const id = chars[i + 1]
      if (id === undefined || stack.pop() !== id) {
        return false
      }
      i++
    } else if (isPuaCodePoint(ch.codePointAt(0) ?? 0)) {
      return false
    }
  }
  return stack.length === 0
}

/**
 * 出力フェイルセーフ: マーカーが整合していればそのまま、不整合ならPUAを全除去して返す。
 * バックエンドの応答組み立て（buildPostView）とフロントの描画前の両方で使う。
 */
export function ensureRenderable(text: string): string {
  return validateMarkers(text) ? text : stripAllPua(text)
}
